import { useMemo } from 'react';

import { useAgentProxyMode } from '@/hooks/use-agent-proxy-mode';
import { useCurrentAgentStatus } from '@/hooks/use-current-agent-status';
import { useCurrentFacility } from '@/hooks/use-current-facility';

/**
 * Whether the session is in agent-proxy mode with the agent reporting online.
 * Used to gate Work Offline nav visibility without coupling other consumers to proxy mode.
 */
export const useLocalOnlineMode = (): boolean => {
  const { agentId } = useCurrentFacility();
  const { isAgentProxyMode } = useAgentProxyMode();
  const { isOffline } = useCurrentAgentStatus();

  return useMemo(() => {
    if (!agentId) return false;
    return isAgentProxyMode && !isOffline;
  }, [agentId, isAgentProxyMode, isOffline]);
};
